import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, TestFrontAppIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof TestFrontAppIntegrationResponseDataSchema>>

export function useTestFrontAppTicketMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof TestFrontAppIntegrationResponseDataSchema>) => {
      const response = await axios.post<Response>(`/integrations/frontapp/test`, data)

      return response.data.data
    },
  })
}
